import cn from "clsx";

import styles from "./Illustration.module.scss";
import ErrorIllustration from "./illustrations/ErrorIllustration.svg";
import TopicIllustration from "./illustrations/TopicIllustration.svg";

const ILLUSTRATION_MAP = {
  error: ErrorIllustration,
  topic: TopicIllustration,
};

const Illustration = ({
  variant,
  size = "normal",
  upscale = false,
}: {
  variant: keyof typeof ILLUSTRATION_MAP;
  size?: "small" | "normal" | "large";
  upscale?: boolean;
}) => {
  const IllustrationElement = ILLUSTRATION_MAP?.[variant];

  return (
    <i
      className={cn([
        styles.illustration,
        styles[size],
        upscale && styles[`${size}-upscale`],
      ])}
    >
      <IllustrationElement
        style={{
          maxWidth: "200px",
          maxHeight: "200px",
        }}
      />
    </i>
  );
};

export { Illustration, ILLUSTRATION_MAP };
